import 'reflect-metadata';
import { ErrorBoundary } from 'react-error-boundary';
import { createRoot } from 'react-dom/client'

import { matchPath } from 'react-router-dom';

import { ChakraProvider } from '@chakra-ui/react';

import '@fontsource/poppins';

import theme from 'view-layer/styled/theme';

import { ErrorFallback } from 'view-layer/components/common/ErrorFallback';

import './index.css';
import { App } from './App';
// import { isProd } from 'business-layer/helpers/env';
import { fetchBaseUrl } from 'data-layer/fetch-api/fetchBaseUrl';
// import { AppConfig,  } from 'app.config';

// import { makeServer } from './server';
import { GlobalContextProvider } from 'business-layer/contexts/GlobalContext';

// if (process.env.NODE_ENV === 'test') {
//   makeServer({ environment: 'test' });
// }

// if (!isProd() && !localStorage.getItem('__api_domain')) {
//   localStorage.setItem('__api_domain', AppConfig.apiDomain);
//   window.location.reload();
// }

(async () => {
  const match = matchPath({ path: '/payment/:hash', end: false }, window.location.hash.replace('#', ''));
  const hash = match?.params?.hash || '';
  const baseurl = localStorage.getItem('__api_domain');
  const newbaseurl = await fetchBaseUrl(hash, true);

  if (newbaseurl !== baseurl) {
    localStorage.setItem('__api_domain', newbaseurl);
    window.location.reload();
  } else {
    const container = document.getElementById('root') as Element;
    const root = createRoot(container);

    const errorHandler = (error: Error, info: {componentStack: string}) => window.console.error('[pay-by-link error]', error);

    root.render(
      <ErrorBoundary FallbackComponent={ErrorFallback} onError={errorHandler}>
        <ChakraProvider theme={theme}>
          <GlobalContextProvider>
            <App/>
          </GlobalContextProvider>
        </ChakraProvider>
      </ErrorBoundary>
    );
  }
})();